/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import React, { useState, useEffect } from "react";
import { ModelHandler } from "../../shared/model/ModelHandler";

/**
 * Component props
 */
export interface IOutputCustomProps<TModelHandler extends ModelHandler = ModelHandler> {
	/** Model handler */
	handler: TModelHandler;

	/** Content renderer */
	render: () => React.ReactElement;
}

/**
 * Model custom output component
 *
 * @param props Props
 */
export function OutputCustom<TModelHandler extends ModelHandler = ModelHandler>(props: IOutputCustomProps<TModelHandler>) {

	// Set initial state
	const [ _state, setState ] = useState(0);

	// Bind on change events
	useEffect(() => {

		const updateHandler = () => {
			setState((s) => s + 1);
		};

		props.handler.on("update", updateHandler);
		updateHandler();

		return () => {
			props.handler.off("update", updateHandler);
		};

	}, [ props.handler ]);

	return props.render();

}
